if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  // ─── Mobile: intercept image tap, show single image fullscreen ───────────────
  if ('ontouchstart' in window) {
    const INITIAL_SCALE = 2.5;
    let scale = INITIAL_SCALE;
    let lastScale = INITIAL_SCALE;
    let tx = 0, ty = 0;
    let isPinching = false;
    let pinchStartDist = 0;
    let panStartX = 0, panStartY = 0;

    // Build a minimal overlay
    const overlay = document.createElement('div');
    overlay.id = 'mz-overlay';
    overlay.style.cssText = `
      display:none; position:fixed; inset:0; z-index:999999;
      background:#000; touch-action:none; overflow:hidden;
      align-items:center; justify-content:center;
    `;

    const img = document.createElement('img');
    img.style.cssText = `
      max-width:100%; max-height:100vh; object-fit:contain;
      transform-origin:center center; user-select:none;
      -webkit-user-drag:none; will-change:transform; display:block;
    `;

    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '✕';
    closeBtn.style.cssText = `
      position:absolute; top:14px; right:14px; z-index:10;
      width:38px; height:38px; border-radius:50%; border:none;
      background:rgba(255,255,255,0.2); color:#fff; font-size:18px;
      cursor:pointer; display:flex; align-items:center; justify-content:center;
    `;

    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    function openOverlay(src) {
      scale = INITIAL_SCALE; tx = 0; ty = 0;
      img.style.transition = 'none';
      img.style.transform = `scale(${INITIAL_SCALE})`;
      img.src = src;
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeOverlay() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      img.src = '';
    }

    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) closeOverlay(); });

    // Touch handlers
    const getDist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    const clamp = (v, mn, mx) => Math.min(Math.max(v, mn), mx);

    const applyTransform = () => {
      img.style.transition = 'none';
      img.style.transform = `translate(${tx}px,${ty}px) scale(${scale})`;
    };

    overlay.addEventListener('touchstart', (e) => {
      if (e.target === closeBtn) return;
      if (e.touches.length === 2) {
        isPinching = true;
        pinchStartDist = getDist(e.touches);
        lastScale = scale;
        e.preventDefault();
      } else if (e.touches.length === 1) {
        isPinching = false;
        panStartX = e.touches[0].clientX - tx;
        panStartY = e.touches[0].clientY - ty;
      }
    }, { passive: false });

    overlay.addEventListener('touchmove', (e) => {
      e.preventDefault();
      if (e.touches.length === 2 && isPinching) {
        scale = clamp(lastScale * (getDist(e.touches) / pinchStartDist), 1, 5);
        applyTransform();
      } else if (e.touches.length === 1 && !isPinching) {
        tx = e.touches[0].clientX - panStartX;
        ty = e.touches[0].clientY - panStartY;
        applyTransform();
      }
    }, { passive: false });

    overlay.addEventListener('touchend', (e) => {
      if (e.touches.length < 2) isPinching = false;
      if (scale <= 1) { scale = INITIAL_SCALE; tx = 0; ty = 0; applyTransform(); }
    });

    // Attach to product slider images only — wait for DOM ready
    function attachToProductSlides() {
      // Only target slides inside the product splide, not anything else on page
      const productSplides = document.querySelectorAll('[id^="x-product-"] .splide__slide, [id^="x-product-"] .x-splide-slide');
      
      productSplides.forEach((slide) => {
        if (slide.dataset.mzReady) return;
        slide.dataset.mzReady = '1';

        slide.addEventListener('click', (e) => {
          // Don't trigger on video/model slides
          if (slide.querySelector('video, model-viewer, iframe')) return;

          const slideImg = slide.querySelector('img');
          if (!slideImg) return;

          // Get highest res src from srcset
          let bestSrc = slideImg.src;
          const srcset = slideImg.srcset || slideImg.getAttribute('data-srcset') || '';
          if (srcset) {
            const parts = srcset.split(',')
              .map(s => s.trim().split(/\s+/))
              .filter(p => p.length >= 2)
              .sort((a, b) => parseInt(b[1]) - parseInt(a[1]));
            if (parts[0] && parts[0][0]) bestSrc = parts[0][0];
          }

          // Block the theme's zoom modal from opening on mobile
          e.stopImmediatePropagation();

          openOverlay(bestSrc);
        }, true); // capture phase — fires before Alpine's click handler
      });
    }

    // Try attaching immediately and after splide loads
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setTimeout(attachToProductSlides, 600));
    } else {
      setTimeout(attachToProductSlides, 600);
    }

    // Re-attach after Splide is ready
    document.addEventListener('eurus:media-gallery-ready', () => setTimeout(attachToProductSlides, 200));
    document.addEventListener('eurus:variant-changed', () => setTimeout(attachToProductSlides, 300));
  }
  // ─────────────────────────────────────────────────────────────────────────────

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        zoomOpen(position, isSplide) {
          // On mobile, our custom overlay handles zoom — skip theme modal
          if ('ontouchstart' in window) return;

          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                childrenArray.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                  childrenArray.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              const target = document.getElementById(position + '-image-zoom-' + settings.section_id);
              if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 300);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => { setup(); });
            return;
          }
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}